import { Injectable } from '@angular/core';
import { Departamento, Empregador, Funcionario, JornadaPonto } from '../api.service';
import { AbaAdministrativa } from '../core/rotas/servico-navegacao-administrativa';
import { ServicoEmpregadorAdministrativo } from '../features/empregador/servico-empregador-administrativo';
import { ServicoFuncionarioAdministrativo } from '../features/funcionario/servico-funcionario-administrativo';
import { ServicoRelogioPonto } from '../features/relogio/servico-relogio-ponto';

export type EstadoAdministrativoShell = {
  aba?: AbaAdministrativa;
  empregadores?: Empregador[];
  empregadorSelecionado?: string;
  empregador?: Empregador;
  relogioEmpregador?: Empregador;
  jornadas?: JornadaPonto[];
  jornadaPonto?: JornadaPonto;
  funcionarios?: Funcionario[];
  departamentos?: Departamento[];
  funcionarioCadastroSelecionado?: string;
  funcionario?: Funcionario;
};

@Injectable({ providedIn: 'root' })
export class ServicoEstadoAdministrativoShell {
  constructor(
    private readonly servicoEmpregadorAdministrativo: ServicoEmpregadorAdministrativo,
    private readonly servicoFuncionarioAdministrativo: ServicoFuncionarioAdministrativo,
    private readonly servicoRelogioPonto: ServicoRelogioPonto
  ) {}

  sessaoAdministrativaLimpa(): EstadoAdministrativoShell {
    return {
      empregadores: [],
      funcionarios: [],
      departamentos: [],
      aba: 'registrador'
    };
  }

  doTenantPublico(tenant: Empregador): EstadoAdministrativoShell {
    return {
      empregadores: [tenant],
      empregadorSelecionado: tenant.id || '',
      empregador: { ...tenant },
      relogioEmpregador: this.servicoRelogioPonto.prepararConfiguracao(tenant)
    };
  }

  daSessaoEmpregadores(
    empregadores: Empregador[],
    empregadorSelecionado: string,
    funcionario: Funcionario
  ): EstadoAdministrativoShell {
    const selecionado = empregadorSelecionado || empregadores[0]?.id || '';
    return {
      empregadores,
      empregadorSelecionado: selecionado,
      funcionario: {
        ...funcionario,
        empregadorId: selecionado
      }
    };
  }

  doEmpregadorCadastro(empregadores: Empregador[], empregadorSelecionado: string): EstadoAdministrativoShell {
    const selecionado = this.empregadorSelecionado(empregadores, empregadorSelecionado);
    return {
      empregador: this.servicoEmpregadorAdministrativo.prepararCadastro(selecionado)
    };
  }

  doRelogioEmpregador(empregadores: Empregador[], empregadorSelecionado: string): EstadoAdministrativoShell {
    const selecionado = this.empregadorSelecionado(empregadores, empregadorSelecionado);
    return {
      relogioEmpregador: this.servicoRelogioPonto.prepararConfiguracao(selecionado)
    };
  }

  dependenciasEmpregadorLimpas(empregadorSelecionado: string): EstadoAdministrativoShell {
    return {
      relogioEmpregador: this.servicoEmpregadorAdministrativo.novoEmpregador(),
      jornadas: [],
      departamentos: [],
      jornadaPonto: this.servicoRelogioPonto.novaJornada(empregadorSelecionado),
      funcionarios: [],
      funcionarioCadastroSelecionado: '',
      funcionario: this.servicoFuncionarioAdministrativo.novoFuncionario(empregadorSelecionado)
    };
  }

  private empregadorSelecionado(empregadores: Empregador[], empregadorSelecionado: string) {
    return empregadores.find(item => item.id === empregadorSelecionado);
  }
}
